import { useBackendData } from 'services/useBackendData';

import { orderService } from './orderService';

export const useSoldStats = (userId?: number) =>
  useBackendData(userId => orderService.fetchItemsSoldCount(userId), userId);
